function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment } from "react";
import styled from "styled-components";
import { RadioLabel, RadioTitle, RadioContent } from "../";
const Icon = styled.svg`
  width: 8px;
  height: 6px;
`;
const HiddenCheckbox = styled.input.attrs({
  type: "checkbox"
})`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
export const StyledCheckbox = styled.div`
  align-items: center;
  box-sizing: border-box;
  background: ${props => props.checked ? props.theme.colors.action : "transparent"};
  border: 1px solid
    ${props => props.checked ? props.theme.colors.action : props.theme.colors.border};
  border-radius: 2px;
  display: inline-flex;
  flex-shrink: 0;
  height: 14px;
  justify-content: center;
  left: 0%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 150ms;
  width: 14px;

  input:disabled + & {
    background: ${props => props.checked ? props.theme.colors.checkboxDisabledCheckedFill : props.theme.colors.checkboxDisabledUncheckedFill};
    border-color: ${props => props.checked ? props.theme.colors.checkboxDisabledCheckedFill : props.theme.colors.checkboxDisabledPath};
  }

  ${Icon} {
    visibility: ${props => props.checked ? "visible" : "hidden"};
  }
`;
const RadioContainer = styled(RadioLabel)`
  @media not screen and ${props => props.theme.media.large} {
    ${props => props.hideCheck && `padding: 0;`}
  }
`;
export const Checkbox = ({
  className,
  onChange,
  title,
  children,
  checked,
  disabled,
  hideCheck = false,
  ...props
}) => {
  const handleChange = e => {
    const {
      target: {
        checked
      }
    } = e;
    return onChange(checked, e);
  };

  return React.createElement(RadioContainer, {
    className: className,
    disabled: disabled,
    doubleLine: !!title,
    hideCheck: hideCheck
  }, React.createElement(HiddenCheckbox, _extends({
    checked: checked,
    onChange: handleChange,
    disabled: disabled
  }, props)), !hideCheck && React.createElement(StyledCheckbox, {
    checked: checked,
    doubleLine: !!title
  }, React.createElement(Icon, {
    viewBox: "0 0 8 6"
  }, React.createElement("path", {
    d: "M6.798 0L8 1.192 3.15 6 0 2.877l1.202-1.192L3.15 3.617z",
    fill: "#FFF"
  }))), !!title && React.createElement(RadioTitle, null, title), React.createElement(RadioContent, {
    doubleLine: !!title
  }, children));
};